/**
 * Test data backing the Autogenerate button on the tranche form.
 *
 * The grades are the form's own — seeded and locked — so this prices them: a rate at every
 * step of a row the reader has not started. The rates honour the schedule's ordering rule in
 * BOTH directions — a flat base rising 2,500 a grade and 150 a step, so every rate beats the
 * step to its left and the grade above it — or the button would fill a form the server
 * refuses. The schedule is public and names nobody, so the amounts are plausible rather than
 * marked.
 */
export const SALARY_GRADES = 33;
export const SALARY_STEPS = 8;

/** A rate at each of the eight steps of `grade`. */
export function sampleRatesFor(grade: number): number[] {
  return Array.from({ length: SALARY_STEPS }, (_, step) => 13000 + (grade - 1) * 2500 + step * 150);
}

/** A tranche between 1 and 20, the range the server accepts. */
export function sampleTranche(): string {
  return String(1 + Math.floor(Math.random() * 20));
}
